import styled from "styled-components"
import * as antd from "antd"

export const WithdrawFormContainer = styled.div`
  background: #FFFFFF;
  border-radius: 20px;
  margin-top: 40px;
  padding: 56px 92px;
  display: flex;
  align-items: center;
  justify-content: center;

  & > .form {
    max-width: 747px;
    @media only screen and (max-width: 1024px) {
      padding: 10px 0;
      margin-top: -20px;
    }
  }

  .ant-row {
    flex-direction: column;
  }

  .ant-input, .ant-form-item-control-input .ant-select-single .ant-select-selector, .ant-input-number {
    background: #FFFFFF !important;
    border: 1px solid #0000001A !important;
  }


  @media only screen and (max-width: 1024px) {
    margin-top: 10px;
    padding: 30px 20px;
    background-color: #FFF;
    .ant-input, .ant-form-item-control-input .ant-select-single .ant-select-selector, .ant-input-number {
      background: #fff !important;
    }
  }

`;

export const Steps = styled.div`
  flex-direction: row;
  display: flex;
  align-items: stretch;
  justify-content: space-between;

  & > div:last-child {
    padding-right: 0;
    width: calc(25%);
  }

  & > div:last-child:before {
    padding-right: 0;
    width: calc(100% + 2px);
  }

  @media only screen and (max-width: 1024px) {
    flex-direction: column;
    padding-left: 12px;
    padding-right: 12px;
  };
`;
export const Step = styled.div`
  width: calc(25% + 30px);
  padding-right: 30px;
  position: relative;
  
  & > div:first-child {
    padding: 40px 32px;
    background: #FFFFFF;
    border-radius: 32px;
    display: flex;
    align-items: flex-start;
    flex-direction: column;
    position: relative;
    height: 100%;
    z-index: 2;
    @media only screen and (max-width: 1024px) {
      padding: 14px 20px;
      border-radius: 16px;
    }
  }

  &:before {
    content: "";
    position: absolute;
    background: linear-gradient(90deg, #e5665b 0%, #e5665b 0.02%, #bc2dbd 20%, #bc2dbd 20.13%, #5f00a7 51%, #5f00a7 51.21%, #393db8 72%, #393db8 72.09%, #048acc 100.01%) !important;
    width: calc(100% - 28px);
    height: calc(100% + 2px);
    left: -1px;
    top: -1px;
    z-index: 1;
    border-radius: 33px;
    @media only screen and (max-width: 1024px) {
      width: calc(100% + 2px);
      height: calc(100% - 28px);
      border-radius: 16px;
    }
  }

  & .arrow {
    position: absolute;
    width: 30px;
    height: 30px;
    background: #000;
    transform: rotate(134deg);
    right: 15px;
    top: calc(50% - 15px);
    z-index: 1;
    @media only screen and (max-width: 1024px) {
      top: auto;
      bottom: 15px;
      right: calc(50% - 15px);
      transform: rotate(224deg);
    }
  }

  & .arrow:after {
    content: "";
    position: absolute;
    width: 31px;
    height: 31px;
    background: #FFFFFF;
    left: 1px;
    top: 1px;
    z-index: 2;
  }

  @media only screen and (max-width: 1024px) {
    width: 100% !important;
    padding-bottom: 30px;
    padding-right: 0;
  };
`;
export const StepHead = styled.div`
  flex-direction: row;
  align-items: center;
  display: flex;
  height: 60px;

  img {
    margin-right: 16px;
  }

  span {
    font-weight: 700;
    font-size: 24px;
    line-height: 30px;
    display: flex;
    color: #202939;
  }
  @media screen and (max-width: 1024px) {
    height: 31px;
    span {
      font-weight: 700;
      font-size: 16px;
    }
    img {
      width: 28px;
      height: 35px;
      margin-right: 12px;
    }
  }
`;
export const StepBody = styled.div`
  font-weight: 400;
  font-size: 16px;
  line-height: 24px;
  color: #697586;
  margin-top: 16px;
  @media screen and (max-width: 1024px) {
    font-size: 14px;
    margin-top: 4px;
    line-height: 20px;
  }
`;

export const Flex = styled.div`
  display: flex;
`

export const Container = styled.div`
  margin-top: 78px;
  padding: 0 300px;
  padding-bottom: 100px;
`

export const Heading = styled.div`

  display: flex;
  align-items: center;

  & span {
    line-height: 30px;
    color: #4D67C1;
  }

`
export const Input = styled(antd.Input)`
  width: 620px;
  @media only screen and (max-width: 500px) {
    & {
      width: 370px;
    }
  };

  padding: 10px 0px 10px 20px;
  box-shadow: 0px 10px 30px 0px rgba(77, 103, 193, 0.149);
  height: 50px;
  background: #FFFFFF;
  border: none;
  box-sizing: border-box;
  border-radius: 16px;
  margin: 0px 0px;

  &::placeholder {
    color: #A3A3A3;
    opacity: 1;
  }

  &:-ms-input-placeholder {
    color: #A3A3A3;
  }

  &::-ms-input-placeholder {
    color: #A3A3A3;
  }
`;

export const InputPassword = styled(antd.Input.Password)`
  padding: 10px 10px 10px 20px;
  width: 100%;
  height: 50px;
  background: #FFFFFF;
  border: 1px solid #707070;
  box-sizing: border-box;
  border-radius: 16px;
  margin: 0px 0px;

  &::placeholder {
    color: #727C8A;
    opacity: 1;
  }

  &:-ms-input-placeholder {
    color: #727C8A;
  }

  &::-ms-input-placeholder {
    color: #727C8A;
  }
`;

export const Select = styled(antd.Select)`
  &.ant-select .ant-select-selector {
    padding: 10px 0px 10px 20px;
    height: auto;
    background: #FFFFFF;
    border: 1px solid #707070;
    box-sizing: border-box;
    border-radius: 16px;
    font-size: 16px;
  }

  &.ant-select .ant-select-selection-search-input {
    height: 48px !important;
    line-height: 48px;
  }

  &.ant-select .ant-select-selection-placeholder {
    height: 30px !important;
    line-height: 30px;
    font-size: 16px;
    color: #747e8c;
  }

  &.ant-select .ant-select-selection-item {
    //height: 24px !important;
    //line-height: 24px;
  }

  &.ant-select .ant-select-arrow {
    right: 32px !important;
  }

  & .ant-select-selection-search-input {
    padding-left: 10px !important;
  }

  & .ant-select-selection-item {
    flex: 1 1;
    overflow: hidden;
    font-weight: normal;
    white-space: break-spaces;
    text-overflow: unset;
  }
`;

export const Faq = styled.div`

  @media only screen and (max-width: 500px) {
    & {
      display: none;
    }
  }
  margin-left: 77px;

  & .faq-item {
    display: flex;
    align-items: center;

    & .faq-txt {
      margin-left: 12px;
      color: #707070;
      font-size: 14;
    }
  }
`

export const Info = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;

  .info-item {
    .info-name {
      width: 128px;
      height: 25px;
      left: 359px;
      top: 550px;

      font-family: 'Helvetica Neue';
      font-style: normal;
      font-weight: 500;
      font-size: 15px;
      line-height: 25px;

      color: rgba(0, 0, 0, 0.5);
    }

    .info-value {
      width: 128px;
      height: 25px;
      left: 358px;
      top: 576px;

      font-family: 'Helvetica Neue';
      font-style: normal;
      font-weight: 500;
      font-size: 15px;
      line-height: 25px;

      color: rgba(0, 0, 0, 0.8);
    }
  }
`

export const Transfer = styled.button`

  float: right;
  width: 112px;
  height: 43px;
  margin-top: 12px;
  font-weight: 600;
  background: #D9D9D9;
  border-radius: 10px;

`

export const ModalContent = styled.div`
  display: flex;
  align-items: center;
  margin-top: 6px;
`

export const ModalNote = styled.div`
  margin: 8px 0;
  padding: 10px 20px;
  background: rgba(217, 217, 217, 0.5);
  border-radius: 10px;
`

export const FormItem = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  margin-bottom: 16px;

  & span {
    width: 30%;
  }

  @media only screen and (max-width: 500px) {
    & {
      display: flex;
      flex-direction: column;
    }

    & span {
      width: 100%;
    }
  }
`

export const FormSelect = styled(antd.Select)`
  width: 620px;
  margin: 0;
  @media only screen and (max-width: 500px) {
    & {
      width: 370px;
    }
  };

  & .ant-select-suffix {
    display: none;
  }

  padding: 0;
  border-radius: 16px;
  box-shadow: 0px 10px 30px 0px rgba(77, 103, 193, 0.149);

  &.ant-select .ant-select-selector {
    padding: 10px 0px 10px 20px;
    height: auto;
    background: #FFFFFF;
    border: none;
    border-radius: 16px;
    box-sizing: border-box;
    font-size: 16px;
  }
`

export const FormInfo = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
`

export const Balance = styled.div`
  display: flex;
  flex-direction: column;
`

export const Fee = styled.div`
  display: flex;
  flex-direction: column;
`

export const Button = styled.button`
  background: linear-gradient(157.48deg, #548FEB -5.34%, #4D67C1 103.65%);
  box-shadow: 0px 5px 15px 0px rgba(23, 40, 253, 0.3333);
  border-radius: 12px;
  outline: none;
  border: none;
  cursor: pointer;
  float: right;
  margin-top: 16px;
  padding: 8px 24px;
  color: white;
  @media only screen and (max-width: 500px) {
    & {
      width: 100%;
    }
  };
`

export const Modal = styled.div`
  padding: 30px 0px;
  position: fixed;
  display: flex;
  justify-content: center;
  margin: auto;
  background-color: rgba(0, 0, 0, 0.3);
  width: 100vw;
  top: 0;
  left: 0;
  height: 100vh;
`

export const Line = styled.div`
  border: 1px solid rgba(0, 0, 0, 0.1);
`

export const ModalContainer = styled.div`
  width: 800px;
  left: 536px;
  top: 138px;

  background: #FFFFFF;
  box-shadow: 0px 16px 36px rgba(104, 109, 132, 0.4157);
  border-radius: 30px;
  overflow-y: scroll;

  &::-webkit-scrollbar {
    display: none;
  }

  & .modal-header {

    padding: 30px 20px;

    h3 {
      font-weight: 500;
      font-size: 25px;
      line-height: 30px;
      /* identical to box height, or 120% */

      text-align: center;
      letter-spacing: -0.96px;

      color: #F12E11;
    }
  }

  & .modal-body {
    padding: 0px 60px;

    & .item {
      margin: 10px 0px;
      display: flex;
      align-items: center;
    }

    & .attention {
      display: flex;
      align-items: center;
      padding: 15px;
      background: #EAF2FF;
      border: 1px solid #CBDFFF;
      border-radius: 10px;
    }
  }

  & .modal-footer {
    padding: 20px 0 40px 0;
    margin: auto;
    display: flex;
    flex-wrap: wrap;
    gap: 18px;
    justify-content: center;
    align-items: center;

    & .cancel-btn {
      width: 120px;
      cursor: pointer;
      height: 42px;
      border: none;
      color: #485EA8;
      outline: none;
      background: linear-gradient(157.48deg, #FFFFFF -5.34%, #FFFFFF 103.65%);
      box-shadow: 0px 5px 15px rgba(23, 40, 253, 0.333333);
      border-radius: 10px;
    }

    & .confirm-btn {
      width: 120px;
      cursor: pointer;
      height: 42px;
      border: none;
      color: #FFFFFF;
      outline: none;
      background: linear-gradient(157.48deg, #548FEB -5.34%, #4D67C1 103.65%);
      box-shadow: 0px 5px 15px rgba(23, 40, 253, 0.333333);
      border-radius: 10px;
    }
  }
`
export const Success = styled.div`
  display: flex;
  margin: auto;
  text-align: center;
  padding: 40px 5px;
  flex-direction: column;
  align-items: center;
  width: 100%;
  justify-content: center;
`

export const Alert = styled.div`
  position: fixed;
  z-index: 9;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  display: flex;
  align-items: center;
  justify-content: center;
`;
export const AlertBg = styled.div`
  background-color: rgba(0, 0, 0, 0.5);
  z-index: 9;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  position: absolute;
`;
export const AlertContent = styled.div`
  position: relative;
  z-index: 10;
  width: 700px;
  background: #FFFFFF;
  box-shadow: 0px 16px 36px rgba(104, 109, 132, 0.4157);
  border-radius: 30px;
  padding: 67px 27px;
  align-items: center;
  display: flex;
  flex-direction: column;
  justify-content: center;

  @media screen and (max-width: 1024px) {
    & {
      padding: 24px;
      width: calc(100% - 24px);
      max-height: 100%;
      overflow-y: auto;
      border-radius: 20px;
    }
  }
`;
export const AlertText = styled.div`
  font-weight: 500;
  font-size: 20px;
  line-height: 30px;
  text-align: center;
  letter-spacing: -0.96px;
  color: #4D67C1;
  margin-top: 22px;
`;

export const SuccessIcon = () => (
    <svg width="68" height="68" viewBox="0 0 68 68" fill="none" xmlns="http://www.w3.org/2000/svg">
        <g clipPath="url(#clip0_1302_9010)">
            <path
                d="M31.6088 46.2161C31.5909 46.2161 31.573 46.2161 31.5541 46.2153C30.857 46.2008 30.1958 45.9026 29.7234 45.3892L16.8239 31.38C15.8654 30.3386 15.932 28.7172 16.9734 27.7587C18.0156 26.8002 19.6362 26.8677 20.5947 27.9083L31.6874 39.9561L62.4326 9.29194C63.4329 8.29239 65.056 8.29412 66.0564 9.29619C67.0559 10.2983 67.0542 11.9214 66.0512 12.9209L33.4181 45.4686C32.938 45.947 32.2863 46.2161 31.6088 46.2161Z"
                fill="#4D67C1"/>
            <path
                d="M34 68C15.2522 68 0 52.747 0 34C0 15.2522 15.2522 0 34 0C35.4155 0 36.5628 1.14723 36.5628 2.56275C36.5628 3.97827 35.4155 5.12563 34 5.12563C18.079 5.12563 5.12563 18.079 5.12563 34C5.12563 49.922 18.079 62.8744 34 62.8744C49.922 62.8744 62.8744 49.922 62.8744 34C62.8744 32.5845 64.0216 31.4373 65.4371 31.4373C66.8526 31.4373 67.9999 32.5845 67.9999 34C68 52.747 52.747 68 34 68Z"
                fill="#4D67C1"/>
        </g>
        <defs>
            <clipPath id="clip0_1302_9010">
                <rect width="68" height="68" fill="white"/>
            </clipPath>
        </defs>
    </svg>
)
export const ErrorIcon = () => (
    <svg width="81" height="68" viewBox="0 0 81 68" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            d="M37.7009 41.3424L36.9449 30.0382C36.7968 27.7635 36.0211 24.0872 37.7583 22.2389C39.0799 20.8174 42.2099 20.5731 43.1605 22.5436C43.9675 24.8582 44.1461 27.3469 43.678 29.7532L42.6653 41.3905C42.6217 42.4863 42.3822 43.5646 41.9574 44.5753C41.6167 45.2416 40.9346 45.6638 40.1859 45.6721C39.4372 45.6794 38.7467 45.2712 38.3923 44.6123C37.9916 43.5646 37.7592 42.4614 37.7009 41.3424ZM40.3202 56.8744C38.4589 56.8642 36.9262 55.4092 36.8198 53.5519C36.7134 51.6934 38.0684 50.0728 39.9158 49.8489C40.8829 49.7321 41.8546 50.02 42.6016 50.6448C43.3484 51.2696 43.8038 52.1746 43.8592 53.1465C43.9149 54.1191 43.5668 55.0706 42.8959 55.7767C42.2258 56.483 41.2937 56.8798 40.3202 56.8744Z"
            fill="#E01B1B"/>
        <path
            d="M72.1209 68H8.47385C5.43166 67.9529 2.64015 66.3036 1.13161 63.6604C-0.376927 61.0179 -0.376927 57.775 1.12995 55.1318L32.9905 4.06029C34.5639 1.53082 37.3339 -0.00543495 40.313 1.44493e-05C43.2924 0.00570078 46.0569 1.55025 47.6209 4.08517L79.4307 55.0726C80.9634 57.7139 80.981 60.9707 79.4779 63.6298C77.9748 66.2877 75.1752 67.951 72.1209 68ZM37.8494 7.01173L5.99153 58.0833C5.51388 58.9651 5.53259 60.0332 6.03962 60.8985C6.54784 61.764 7.47045 62.3006 8.47385 62.3137H72.1209C73.1355 62.298 74.0664 61.7481 74.5689 60.8672C75.0717 59.9861 75.0717 58.904 74.5689 58.0231C74.5689 58.0231 42.7593 7.02832 42.7454 7.01173C42.2132 6.17324 41.2897 5.66597 40.2974 5.66597C39.3051 5.66597 38.3816 6.17324 37.8494 7.01173Z"
            fill="#E01B1B"/>
    </svg>
)
export const CancelIcon = () => (
    <svg width="68" height="68" viewBox="0 0 68 68" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            d="M55.25 68H12.75C5.70788 68 0 62.2921 0 55.25V12.75C0 5.70788 5.70788 0 12.75 0H55.25C62.2921 0 68 5.70788 68 12.75V55.25C68 62.2921 62.2921 68 55.25 68Z"
            fill="#E01B1B" fillOpacity="0.1"/>
        <path
            d="M36.0043 34.0002L44.5188 25.4852C45.0713 24.9327 45.0713 24.0362 44.5188 23.4816C43.9663 22.927 43.0698 22.9291 42.5152 23.4816L34.0002 31.9961L25.4852 23.4816C24.9327 22.9291 24.0362 22.9291 23.4816 23.4816C22.927 24.0341 22.9291 24.9306 23.4816 25.4852L31.9961 34.0002L23.4816 42.5152C22.9291 43.0677 22.9291 43.9642 23.4816 44.5188C23.7576 44.7953 24.1212 44.9333 24.4823 44.9333C24.8454 44.9333 25.2071 44.7953 25.4831 44.5188L34.0002 36.0043L42.5152 44.5188C42.7912 44.7953 43.155 44.9333 43.516 44.9333C43.8771 44.9333 44.2407 44.7953 44.5168 44.5188C45.0693 43.9663 45.0693 43.0698 44.5168 42.5152L36.0043 34.0002Z"
            fill="#E01B1B"/>
    </svg>

)